import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6LeAuYkqAAAAAGTfw4B-7h5m9Gpd7Pxnam7x-xiY",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});